// import 'slick-carousel'
// import GOOGLEMAP from '../plugins/googlemap'
import Swiper from 'swiper/swiper-bundle';
import GET_ARTICLES from '../plugins/getArticles'
import GET_INSTAGRAM from '../plugins/getInstagram'

const [ w, l ] = [ window, location ]
export default function HOME() {
  // mvSlide
  setTimeout(() => {
    const mvSlide = new Swiper('.mv_slide[data-plugin="mainSlider"]',{
      loop: true,
      effect: 'fade',
      speed: 0,
      allowTouchMove: false,
      fadeEffect: {
        crossFade: true, // クロスフェードを有効にする（フェードモードの場合 true 推奨）
      },
			autoplay: {
        delay: 6000,
				disableOnInteraction: false,
        waitForTransition: false
			},
			pagination: {
				el: '.mv-pager',
				type: 'bullets',
				clickable: true,
				renderBullet: function (index, className) {
					return (
					`<div class="${ className }">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18"><circle cx="9" cy="9" r="8" /></svg>
          </div>`
					)
				}
			},
			// on: {
			// 	slideChange: function (item) {
			// 		console.log(this.realIndex);
			// 		const index_currentSlide = this.realIndex + 1;
			// 		const currentSlide = this.slides[index_currentSlide]

			// 		$(currentSlide).addClass('activeimage');
			// 		setTimeout(function(){
			// 		$(currentSlide).removeClass('activeimage');
			// 		}, 7000);
			// 	}
			// },
    });

    // news
    // const news_ticker = new GET_ARTICLES('.mainvisual .news_wrap[data-plugin="getArticles"]');
    // news_ticker.makeItem = (item,content) => `
    //   <a href="${item.href}">
    //     <p class="date">${item.date}</p>
    //     <p class="ttl">${item.title}</p>
    //     <div class="arrow_wrap">
    //       <svg class="arrow"><use xlink:href="/asset/svg/sprite.symbol.svg#arrow"></use></svg>
    //     </div>
    //   </a>`;
    // // news_ticker.makeItem = (item) => console.log(item);
    // news_ticker.render();

    let makeItem = item => $(`
      <a href="${item.href}">
        <p class="date">${item.date}</p>
        <p class="ttl">${item.title}</p>
        <div class="arrow_wrap">
          <svg class="arrow"><use xlink:href="/asset/svg/sprite.symbol.svg#arrow"></use></svg>
        </div>
      </a>
    `)[0]
    GET_ARTICLES('.mainvisual .news_wrap[data-plugin="getArticles"]', { makeItem });

  }, 500);

  // mainvisual scroll
  $(window).on('load scroll', function(){
    let scroll = $(this).scrollTop();
    if(scroll < 600){
      $('.about_bg').css('opacity','0.0015' * scroll);
      $('.mainvisual').css('filter','blur('+ 0.003 * scroll + 'px');
    } else {
      $('.about_bg').css('opacity', '.9');
      $('.mainvisual').css('filter','blur(4px');
    }
  });

  // news
  $.when(w.load['block-news']).then( () => {
    setTimeout(() => {
      let makeItem = item => $(`
        <li>
          <a href="${item.href}">
            <p class="info">
              <span class="date">${item.date}</span>
              <span class="cate">${item.category.name}</span>
            </p>
            <p class="subject ${item.is_new ? 'is-new': ''}">${item.title}</p>
            <svg class="arrow"><use xlink:href="/asset/svg/sprite.symbol.svg#arrow"></use></svg>
          </a>
        </li>
      `)[0]
      GET_ARTICLES('.news_list[data-plugin="getArticles"]', { makeItem });
    }, 500);
  });

  // insta
  if( w.load['loadHtml'] ){
    $.when( w.load['products01'], w.load['products02'], w.load['products03'] ).done( () => {
    });
    setTimeout(() => {
      GET_INSTAGRAM()
    }, 500);
  }

  // map script
  // const km = w.siteinfo.mapApiKeys
  // const env_map_key = (!km[host]) ? km['local'] : km[host]
  // w.addScript({src:`https://maps.googleapis.com/maps/api/js?v=3&key=${env_map_key}&callback=load.mapScript.resolve`})
  
  $(() => {
  
    /*****
     * Slick実行
     */
    // $('[data-plugin="slider"]').slick({
    //   autoplay:true,
    //   fade: true,
    //   dots: true,
    //   speed: 1200,
    //   autoplaySpeed: 4000,
    //   pauseOnHover: false,
    //   pauseOnFocus: false,
    //   arrows: true
    // })
  
  })


  // map
  // document.addEventListener( 'DOMContentLoaded', () => {
  //   $.when(
  //     w.load['mapScript'],
  //     w.load['contentFooter']
  //   ).done( () => GOOGLEMAP() )
  // } )
}